export class Evaluation {

	constructor() {}

	lead(e,obj)
	{

		e.preventDefault()
		let _this = this
		let start = performance.now()
		let loader = document.querySelector('.evaluation__form > .form__loader')
		loader.classList.add('active')

		let yaClient = '';
		if (window.hasOwnProperty('yaCounter87397587'))
			yaClient = yaCounter87397587.getClientID();

		$.ajax({
			url: "/ajax.php?mid=10",
			type: 'POST',
			data: {
				action: 'evaluation',
				regionCode: obj.regionCode.value,
				address: obj.address.value,
				square: obj.square.value,
				email: obj.email.value,
				object: this.object,
				yaClientID: yaClient,
			},
			dataType: "json",

			success: function (res) {
				if (res['error']) {
					alert(res['error'])
				} else {
					_this.prepareTime(loader,start,res)
					if (window.hasOwnProperty('yaCounter87397587'))
						yaCounter87397587.reachGoal('GetPropertyForm-send')
				}
			},
			error: function (error) {
				alert('Сервис временно недоступен! Пожалуйста, попробуйте ещё раз или обратитесь к администратору сайта')
			}
		})

	}

	showSuccess(loader,res) {
		let form = document.querySelector('.evaluation__form > .form__main')
		form.style.display = 'none'
		let formSuccess = document.querySelector('.evaluation__form > .form__success')
		formSuccess.style.display = 'block'

		let evaluationSuccess = document.createElement('div')
		evaluationSuccess.classList.add('evaluation__success')

		let pcb1 = document.createElement('div')
		pcb1.classList.add('evaluation__success-block')
		evaluationSuccess.appendChild(pcb1)

		let pcd1 = document.createElement('div')
		pcd1.classList.add('evaluation__success-caption')
		pcd1.append('Стоимость вашей недвижимости')
		pcb1.appendChild(pcd1)

		let pcv1 = document.createElement('div')
		pcv1.classList.add('evaluation__success-value')
		let price = res.item.cost
		pcv1.append(price.toLocaleString() + "\u00A0₽")
		pcb1.appendChild(pcv1)

		let pcb2 = document.createElement('div')
		pcb2.classList.add('evaluation__success-block')
		evaluationSuccess.appendChild(pcb2)

		let pcd2 = document.createElement('div')
		pcd2.classList.add('evaluation__success-caption')
		pcd2.append('Доступная сумма для кредитования')
		pcb2.appendChild(pcd2)

		let pcv2 = document.createElement('div')
		pcv2.classList.add('evaluation__success-value')
		let credit = Math.round(price * 0.75)
		pcv2.append(credit.toLocaleString() + "\u00A0₽")
		pcb2.appendChild(pcv2)

		formSuccess.appendChild(evaluationSuccess)
		loader.classList.remove('active')
	}

	prepareTime(loader,start,res) {
		let _this = this
		let end = performance.now()
		let time = end - start
		if(time < 200) {
			time = 200 - time
			setTimeout(function(){_this.showSuccess(loader,res)}, time);
		} else {
			this.showSuccess(loader,res)
		}
	}

	range(event) {
		let isRTL = document.documentElement.dir === 'rtl'
		let target = event.target
		let val = target.value
		let min = target.min
		let max = target.max
		if(event.target.type !== 'range') {
			target = document.getElementById('range')
			let value = ''
			event.target.addEventListener('input', function(e){
				if(this.checkValidity()){
					value = this.value
					if(value < this.min) value = this.min
					if(value > this.max) value = this.max
				} else {
					value = value.replace(/\d+/g, '')
					if(value == '') value = this.min
					this.value = value
				}
				if(target.value == this.max)
					this.value = this.max
			})
			event.target.onblur = function() {
				if(event.target.value == '')
					event.target.value = 1
			}
		} else {
			document.getElementById('rangenumber').value = val
		}
		target.value = val
		let percentage = (val - min) * 100 / (max - min)
		if (isRTL) {
			percentage = (max - val)
		}
		if(percentage < 0) {
			percentage = 0
			target.value = 1
		}
		target.style.backgroundSize = percentage + '% 100%'
	}

}